import axios from 'axios'

// Get all transactions for business
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/payment-fee`)
  return data
}

export {
  getAll
}
